var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navBar',{attrs:{"title":"Ares - Guest messages","home":true,"type":"guestmessages"}})
}
var staticRenderFns = []

export { render, staticRenderFns }